import { fileUrl } from "@/lib/api";

const monogram = (name = "") => {
  const paren = name.match(/\(([^)]+)\)/);
  if (paren) {
    const a = paren[1].replace(/[^A-Za-z0-9]/g, "");
    if (a.length >= 2) return a.slice(0, 3).toUpperCase();
  }
  const words = name.replace(/\([^)]*\)/g, "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

const SIZES = {
  sm: "h-11 w-11 text-sm",
  md: "h-14 w-14 text-base",
  lg: "h-20 w-20 text-2xl",
};

export const CompanyMonogram = ({ name, logo, size = "sm", className = "", testid }) => {
  if (logo) {
    return (
      <span data-testid={testid} aria-label={`${name} logo`} className={`relative flex shrink-0 items-center justify-center overflow-hidden border border-slate-200 bg-white p-1 ${SIZES[size]} ${className}`}>
        <img src={fileUrl(logo)} alt={`${name} logo`} className="h-full w-full object-contain" loading="lazy" />
      </span>
    );
  }
  return (
    <span
      data-testid={testid}
      aria-label={`${name} logo`}
      className={`relative flex shrink-0 items-center justify-center overflow-hidden border border-[#6D28D9]/30 bg-gradient-to-br from-[#EDE9FE] to-[#FAF9FF] font-display font-semibold tracking-tight text-[#6D28D9] ${SIZES[size]} ${className}`}
    >
      <span className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(109, 40, 217,0.18),transparent_60%)]" />
      <span className="relative">{monogram(name)}</span>
    </span>
  );
};
